import styled from "styled-components";

export const FiltersMobileIconDefaultBox = styled.i`
      position: absolute;
      width: 20px;
      height: 22px;
      background-image: url("${props => props.theme.assets.images.SpriteSheetPC1920_png.toString()}");
      background-position: -446px -521px;
      background-repeat: no-repeat;
`;